import { StyledDatagrid } from 'pages/Gateways/GatewaysShow/GatewaysShow.styled';
import { ListContextProvider, useList, useRecordContext } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from 'shared/mui/Link/Link';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { BooleanField, FunctionField, TextField } from 'shared/react-admin/Fields';
import { Gateway, GatewayMethod } from 'types/embedded/gateway';

export const GatewaysShowTableMethodsDatagrid: React.FC = () => {
  const record = useRecordContext<Gateway>();

  const gatewayMethods = record?.gatewayMethods ?? [];

  const gatewayMethodsListContext = useList({
    data: gatewayMethods,
    perPage: 10,
    sort: { field: 'id', order: 'ASC' },
  });

  if (!gatewayMethods.length) {
    return null;
  }

  return (
    <ListContextProvider value={gatewayMethodsListContext}>
      <StyledDatagrid bulkActionButtons={false}>
        <FunctionField
          label="Метод"
          render={(method: GatewayMethod) => (
            <Link
              component={RouterLink}
              sx={{ color: 'primary.main' }}
              target="_blank"
              to={`/methods/${encodeURIComponent(method.method?.['@id'])}/show`}
            >
              <TextField label="Метод" sortable={false} source="methodName" />
            </Link>
          )}
          sortable={false}
          source="methodName"
        />
        <BooleanField label="Активен" sortable={false} source="active" />
        <BooleanField label="Тестирование" sortable={false} source="pilotMode" />
        <BooleanField
          label={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span lang="ru" style={{ marginRight: '4px' }}>
                Автоотключение
              </span>
              <TooltipWithInfoIcon tooltipText="Режим тестирования будет отключён при создании первого заказа в системе." />
            </div>
          }
          sortable={false}
          source="autoDeactivation"
        />
      </StyledDatagrid>
    </ListContextProvider>
  );
};
